import _ from 'lodash';
import { Guest } from '@swiper/core';
import { Service } from './Service';
import { log, now, ndjson } from '~/utils';

export class GuestsService extends Service {

  get name() { return 'guests'; }
  get idprefix() { return 'guest'; }
  get extension() { return '.ndjson'; }

  async get( id, params ) {
    const membershipId = id.split( '@' )[1];
    if ( ! membershipId ) {
      throw new Error( `Cannot get guest without membershipId` );
    }
    const guest = await ndjson.read( this.pathto( membershipId ), {
      ignoreErrors  : true,
      filter        : { id },
      reverse       : true,
      limit         : 1,
      model         : Guest,
      array         : false,
    } );
    if ( ! guest ) throw new Error( `Guest ${id} not found` );
    log.debug( 'RETURNING GUEST', guest );
    return guest;
  }

  async create( data, params ) {
    const { membershipId, ...guestinfo } = data;
    if ( ! membershipId ) {
      this.throw( 'BadRequest', `Cannot create guest without membershipId` );
    }
    if ( ! guestinfo.name ) {
      this.throw( 'BadRequest', `Cannot create guest without name` );
    }
    guestinfo.ts = now();
    guestinfo.id = this.generateId( membershipId );
    // const guests = await ndjson.reader( this.pathto( membershipId ) );
    // guestinfo.id = [ 'guest', membershipId, guests.length + 1 ].join( '@' );
    await ndjson.append( this.pathto( membershipId ), guestinfo );

    return new Guest( guestinfo );
  }

  async find( { query, ...params } ) {
    const { membershipId, $limit, name } = query;
    if ( ! membershipId ) {
      this.throw( 'BadRequest', 'Cannot find guests without membershipId' );
    }
    const opts = {
      reverse   : true,
      model     : Guest,
    };
    if ( name ) {
      const re = new RegExp( name, 'iu' );
      log.debug( 'filter', re );
      opts.filter = rec => re.test( rec.name );
    }
    if ( $limit ) opts.limit = $limit;

    const records = await ndjson.read( this.pathto( membershipId ), opts );
    log.debug( 'BUILT GUESTS', records );
    return records;
  }

}

export const hooks = {
  before  : { all : [ 'auth' ] },
};
